import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-scrollable',
  templateUrl: './lib-scrollable.component.html',
  styleUrls: ['./lib-scrollable.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibScrollableComponent {
  @Input() isHorizontal?: boolean;
}
